import { Drawer, message, Spin } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { useDispatch, useSelector } from "react-redux";
import { userLoaded } from "../../redux/actions";
import { useViewportBreakpoint } from "../../hooks/useViewportBreakpoint";
import NavMenuItem from "./nav-menu-item";
import "./nav-menu.css";

const NavMenu = () => {
  const d = useDispatch();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const viewport = useViewportBreakpoint();
  const user = useSelector((s) => s.user);
  const isMobile = viewport === 'mobile';

  useEffect(() => {
    user && checkSession();
  }, [user]);
  
  const checkSession = () => {
    serverFetch("auth/CheckSession")
      .then(data => {
        if (data.support !== user.support) {
          d(userLoaded(data));
          // Обновляем компонент, чтобы изменения в user.support отразились в меню
          window.location.reload();
        }
      })
      .catch(e => {
        if (e.statusCode === 500) d(userLoaded(null));
      })
  }

  const onLogout = () => {
    setLoading(true);
    serverFetch("auth/logout", { method: "POST" })
      .then(() => {
        setLoading(false);
        d(userLoaded(null));
      })
      .catch(e => {
        setLoading(false);
        d(userLoaded(null));
        message.error(e.userMessage);
      })
  }

  // const support = session?.support ?? true;
  // console.log(user);
  
  useEffect(() => {
    const newItem = [
      getItem('Компания', 'company', '/', 'home.svg'),
      getItem('Заказы', 'orders', '/orders', 'order.svg'),
      getItem('Задачи', 'tasks', '/tasks', user.support ? 'calendar.svg' : 'calendar-block.svg', null, user.support ? false : true),
      getItem('Пакеты', 'packets', '/packets', 'pack.svg'),
    ];
    user?.admin && newItem.push(getItem('Компании', 'companies', '/companies', 'admin.svg'));
    newItem.push(getItem('Лицензии', 'licenses', '/licenses', 'license.svg'));
    newItem.push(getItem('Сообщения', 'messages', '/messages', 'mail-b.svg'));
    newItem.push(getItem('Поддержка', 'support', '/support', 'support.svg'));
    user?.admin && newItem.push(getItem('Настройки', 'settings', '/settings', 'settings.svg'));
    newItem.push(getItem('Выход', 'logout', '', 'exit.svg', onLogout));
    setItems(newItem);
  }, [])

  const getItem = (label, key, urlTo, img, onClick, disabled = false)  => ({ key, label, url: urlTo, img, onClick, disabled });

  const closeDrawer = () => setDrawerOpen(false);

  const menuItems = items.map((i) => {
    const { onClick, ...rest } = i;
    const wrappedOnClick =
      onClick && isMobile
        ? () => {
            closeDrawer();
            onClick();
          }
        : onClick;
    return (
      <NavMenuItem
        {...rest}
        key={i.key}
        onClick={wrappedOnClick}
        onNavigate={isMobile ? closeDrawer : undefined}
      />
    );
  });

  const menuBlock = (
    <>
      <div className="sider-logo-new"><a href="/"><img src="/images/logo.svg" alt="logo" /></a></div>
      {menuItems}
      <div className="nav-menu-footer">{process.env.REACT_APP_VERSION}</div>
    </>
  );

  if (loading) return <Spin />;

  if (isMobile) {
    return (
      <div className="nav-shell nav-shell--mobile">
        <header className="nav-mobile-bar">
          <button type="button" className="nav-mobile-menu-btn" onClick={() => setDrawerOpen(true)} aria-label="Меню">
            <MenuOutlined />
          </button>
          <a href="/" className="nav-mobile-logo"><img src="/images/logo.svg" alt="logo" /></a>
        </header>
        <Drawer
          title={null}
          placement="left"
          width={288}
          onClose={closeDrawer}
          open={drawerOpen}
          styles={{ body: { padding: 0 } }}
          className="nav-drawer"
        >
          <div className="nav-menu-container nav-menu-container--drawer">
            {menuBlock}
          </div>
        </Drawer>
      </div>
    );
  }

  return (
    <div className="nav-shell nav-shell--side">
      <div className="nav-menu-container">
        {menuBlock}
      </div>
    </div>
  );
}

export default NavMenu;